<div *ngIf="userId && verifyMethod">
  <dx-verify [userID]="userId" [method]="verifyMethod" (success)="receivedDataHandler($event)" [allowCloseableModal]="true"></dx-verify>
</div>
